export const ThemeList = {
  light: {
    // bgColors
    '--primary-background': '#fafafa',
    '--primary-header-bg': '#ffffff',
    '--primary-elements-bg': '#efefef',
    '--primary-elements-bg-hover': '#f5f5f5',
    '--navigation-tree-bg': '#fafafa',
    '--dropdown-bg-selected': '#f6f6f6',
    '--element-bg-color-1': '#fafafa',
    '--input-group-background': '#3E3E3E',
    '--popover-bgColor': '#000',
    '--background-selected': '#efefef',
    '--list-font-color': '#1B1B1B',
    '--folder-bgcolor': '#7a7a7a',
    '--tooltip-font-color': '#232525',
    '--checkbox-bg': '#ffffff',
    //End bgColors

    //Font Colors
    '--separator-color': '#e7e7e7',
    '--primary-font-color': '#7a7a7a',
    '--secondary-font-color': '#b5b5b5',
    '--primary-font-color-selected': '#3e3e3e',
    '--input-box-font-color': '#000',
    '--header-basic-font': '#3e3e3e',
    '--button-gray-number': '#eee',
    //End Font Colors

    //Buttons
    '--primary-style-color': '#EC7265',
    '--primary-style-color-trans': '#EC726533',
    '--primary-box-shadow': '#eb6a5c99',
    '--primary-style-shadow': 'rgba(235, 106, 92, 0.1)',
    '--input-progress-bar': '#d4d4d4',
    //End Buttons

    // Borders
    '--border-color-1': '#e7e7e7',
    '--input-box-border-1': 'none',
    '--primary-shadow-color': '#E0E0E0',
    '--modal-background': 'rgba(0, 0, 0, 0.2)',
    '--box-shadow-primary': 'rgb(224, 224, 224)',
    // images
    '--upload-asset-image': 'url(images/themes/light/upload_asset.svg)',
    '--icon-text-colored': 'url(images/themes/light/icon_text_colored.svg)',
    '--icon-rect': 'url(images/themes/light/rect.svg)',
    '--icon-circle': 'url(images/themes/light/circle.svg)',
    '--icon-star-empty': 'url(images/themes/light/star_empty.svg)',
    '--icon-line': 'url(images/themes/light/line.svg)',
    '--icon-path': 'url(images/themes/light/path.svg)',
    '--icon-trash-colored': 'url(images/themes/light/trash_red.svg)',
    '--icon-img-colored': 'url(images/themes/light/img.svg)',
    '--icon-edit-asset': 'url(images/themes/light/edit_asset.svg)',
    '--icon-play': 'url(images/themes/light/play.svg)',
    '--icon-pause': 'url(images/themes/light/pause.svg)',
    '--icon-hand': 'url(images/themes/light/hand.svg)',
    '--icon-comment_paint': 'url(images/themes/light/comment_paint.svg)',
    '--icon-comment_point': 'url(images/themes/light/comment_point.svg)',
    '--icon-360_flat': 'url(images/themes/light/360_flat.svg)',
    '--icon-360_spherical': 'url(images/themes/light/360_spherical.svg)',
    '--icon-speaker':'url(images/themes/light/speaker_icon.svg)',
    '--icon-speaker-muted': 'url(images/themes/light/speaker_icon_muted.svg)',
    '--loop-back' : 'url(images/themes/light/loop_back.svg)',
    '--icon_radio_checked': 'url(images/themes/light/icon_radio_checked.svg)',
    '--icon_radio_unchecked': 'url(images/themes/light/icon_radio_unchecked.svg)'
  },
  dark: {
    // bgColors
    '--primary-background': '#2d2f2f',
    '--primary-header-bg': '#1b1b1b',
    '--checkbox-bg': '#232525',
    '--primary-elements-bg': '#3e3e3e',
    '--primary-elements-bg-hover': '#3a3a3a',
    '--navigation-tree-bg': '#232525',
    '--dropdown-bg-selected': '#232525',
    '--element-bg-color-1': '#1b1b1b',
    '--input-group-background': '#3e3e3e00',
    '--popover-bgColor': '#fff',
    '--background-selected': '#b5b5b5',
    '--list-font-color': '#1b1b1b',
    '--folder-bgcolor': '#3e3e3e',
    '--tooltip-font-color': '#f6f6f6',
    //End bgColors

    //Font Colors
    '--primary-font-color': '#b5b5b5',
    '--primary-font-color-selected': '#efefef',
    '--secondary-font-color': '#7a7a7a',
    '--separator-color': '#3e3e3e',
    '--input-box-font-color': '#fff',
    '--header-basic-font': '#e7e7e7',
    '--button-gray-number': '#2d2f2f',
    //End Font Colors

    //Buttons
    '--primary-style-color': '#fad923',
    '--primary-style-color-trans': '#fad92333',
    '--primary-box-shadow': '#f0eb6099',
    '--primary-style-shadow': 'rgba(250, 217, 35, 0.1)',
    '--input-progress-bar': '#2d2f2f',
    //End Buttons

    //Borders
    '--border-color-1': '#1b1b1b',
    '--input-box-border-1': '1px solid #7a7a7a',
    '--primary-shadow-color': '#232525',
    '--modal-background': 'rgba(0, 0, 0, 0.5)',
    '--box-shadow-primary': 'rgb(0, 0, 0, 0.3)',
    // images
    '--upload-asset-image': 'url(images/themes/dark/upload_asset.svg)',
    '--icon-text-colored': 'url(images/themes/dark/icon_text_colored.svg)',
    '--icon-rect': 'url(images/themes/dark/rect.svg)',
    '--icon-circle': 'url(images/themes/dark/circle.svg)',
    '--icon-star-empty': 'url(images/themes/dark/star_empty.svg)',
    '--icon-line': 'url(images/themes/dark/line.svg)',
    '--icon-path': 'url(images/themes/dark/path.svg)',
    '--icon-trash-colored': 'url(images/themes/dark/trash_red.svg)',
    '--icon-img-colored': 'url(images/themes/dark/img.svg)',
    '--icon-edit-asset': 'url(images/themes/dark/edit_asset.svg)',
    '--icon-play': 'url(images/themes/dark/play.svg)',
    '--icon-pause': 'url(images/themes/dark/pause.svg)',
    '--icon-hand': 'url(images/themes/dark/hand.svg)',
    '--icon-comment_paint': 'url(images/themes/dark/comment_paint.svg)',
    '--icon-comment_point': 'url(images/themes/dark/comment_point.svg)',
    '--icon-360_flat': 'url(images/themes/dark/360_flat.svg)',
    '--icon-360_spherical': 'url(images/themes/dark/360_spherical.svg)',
    '--icon-speaker':'url(images/themes/dark/speaker_icon.svg)',
    '--icon-speaker-muted': 'url(images/themes/dark/speaker_icon_muted.svg)',
    '--loop-back' : 'url(images/themes/dark/loop_back.svg)',
    '--icon_radio_checked': 'url(images/themes/dark/icon_radio_checked.svg)',
    '--icon_radio_unchecked': 'url(images/themes/dark/icon_radio_unchecked.svg)'
  }
};
